import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TemplateCategoriesComponent } from './template-categories.component';
import { AddTemplateCategoryComponent } from './add-template-category/add-template-category.component';
import { CategoryAssignmentDialogComponent } from './category-assignment-dialog/category-assignment-dialog.component';
import { EditTemplateCategoryComponent } from './edit-template-category/edit-template-category.component';
import { TemplateCategoryTreeComponent } from './template-category-tree/template-category-tree.component';
import { TemplateOrganizationBrowserComponent } from './template-organization-browser/template-organization-browser.component';

import { MaterialModule } from 'src/app/material.module';
import { MatTreeModule } from '@angular/material/tree';

import { DataTablesModule } from 'angular-datatables';

import { TemplateCategoriesService } from './template-categories.service';

const routes = [
    {
        path: '',
        component: TemplateCategoriesComponent
    }
];

@NgModule({
    declarations: [
        TemplateCategoriesComponent,
        AddTemplateCategoryComponent,
        CategoryAssignmentDialogComponent,
        EditTemplateCategoryComponent,
        TemplateCategoryTreeComponent,
        TemplateOrganizationBrowserComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        MatTreeModule,

        DataTablesModule
    ],
    providers: [
        TemplateCategoriesService
    ],
    exports: [
        TemplateCategoriesComponent
    ]
})
export class TemplateCategoriesModule { }
